module.exports = "<span class=\"m-1\"><b><span>Consecutivo del sistema</span>:</b> {{tramite_id}}</span>\n<span class=\"m-1\"><b> <span>Codigo de la liquidacion</span>:</b>{{liquidacion_id }}</span>\n<!-- Contenedor de los formularios dinamicos para el auto guardado -->\n<ng-container #componentFormAutoSave></ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/all/instance-liquidation/load-task/load-task.component.html
// module id = ./src/app/forms/all/instance-liquidation/load-task/load-task.component.html
// module chunks = main